import { HTMLAttributes } from 'react';

export type SvgIconProps = HTMLAttributes<SVGSVGElement> & {
    /**
     * Relative URL to the SVG file.
     */
    component: SVGComponent;
    /**
     * Size (width and height) of the icon.
     */
    size?: number;
    /**
     * Width of the SVG icon, overrides the size.
     */
    width?: number;
    /**
     * Height of the SVG icon, overrides the size.
     */
    height?: number;
};

/**
 * Default size of the SVG component.
 */
const defaultSize = 16;

export function SvgIcon({
    component: Component,
    size,
    width: givenWidth,
    height: givenHeight,
    color,
    ...rest
}: SvgIconProps) {
    const width = givenWidth ?? size ?? defaultSize;
    const height = givenHeight ?? size ?? defaultSize;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            color={color}
            fill={color ?? 'currentColor'}
            style={{
                display: 'inline-block',
                verticalAlign: 'middle',
            }}
            role="presentation"
            {...rest}
        >
            <Component width={width} height={height} />
        </svg>
    );
}
